import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getStorage } from 'firebase/storage'

// Your Firebase configuration
// Replace these values with your Firebase project settings
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || 'YOUR_API_KEY',
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || 'YOUR_AUTH_DOMAIN',
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || 'ndza-site',
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || 'YOUR_STORAGE_BUCKET',
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || 'YOUR_SENDER_ID',
  appId: process.env.VUE_APP_FIREBASE_APP_ID || 'YOUR_APP_ID'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
const db = getFirestore(app)
const auth = getAuth(app)
const storage = getStorage(app)

export { db, auth, storage }
